function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "background"), React.createElement("rect", {
  fill: "none",
  id: "canvas_background",
  height: 18,
  width: 118,
  y: -1,
  x: -1
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("title", null, "Layer 1"), React.createElement("g", {
  id: "svg_1"
}, React.createElement("defs", {
  transform: "translate(0.0000018310549876332516,0) "
}, React.createElement("rect", {
  height: 3117.421,
  width: 1285.902,
  y: 257.811,
  x: 145.548,
  id: "SVGID_1_"
})), React.createElement("clipPath", {
  transform: "translate(0.0000018310549876332516,0) ",
  id: "SVGID_2_"
}, React.createElement("use", {
  id: "svg_2",
  xlinkHref: "#SVGID_1_"
}))), React.createElement("path", {
  id: "svg_3",
  d: "m107.167,15.303001l0,-6.944l4.8,6.944l3.9,0l-5.271,-7.694l5.058,-7.308l-3.9,0l-4.586,6.516l0,-6.516l-3.43,0l0,15.002l3.429,0zm-13.253,0.299c2.743,0 5.145,-1.35 6.431,-3.472l-2.959,-1.715c-0.643,1.158 -1.949,1.843 -3.472,1.843c-2.657,0 -4.371,-1.778 -4.371,-4.457c0,-2.68 1.714,-4.458 4.371,-4.458c1.522,0 2.809,0.686 3.472,1.843l2.959,-1.714c-1.308,-2.122 -3.708,-3.472 -6.431,-3.472c-4.521,0 -7.801,3.386 -7.801,7.801s3.279,7.801 7.801,7.801zm-18.675,-3.343c-2.442,0 -4.371,-1.778 -4.371,-4.457c0,-2.68 1.929,-4.458 4.371,-4.458c2.444,0 4.373,1.778 4.373,4.458c0,2.678 -1.929,4.457 -4.373,4.457zm0,3.343c4.309,0 7.802,-3.386 7.802,-7.801s-3.493,-7.801 -7.802,-7.801c-4.307,0 -7.801,3.386 -7.801,7.801s3.494,7.801 7.801,7.801zm-15.909,-8.229l-2.57,0l0,-3.858l2.57,0c0.943,0 1.715,0.837 1.715,1.93s-0.772,1.928 -1.715,1.928zm-2.571,7.93l0,-4.929l1.629,0l2.828,4.929l3.687,0l-3.193,-5.508c1.65,-0.836 2.765,-2.507 2.765,-4.351c0,-2.852 -2.293,-5.144 -5.145,-5.144l-6,0l0,15.002l3.429,0l0,0.001zm-13.466,0.299c3.301,0 5.787,-1.929 5.787,-5.144l0,-10.158l-3.43,0l0,9.858c0,1.136 -0.536,2.1 -2.357,2.1c-1.822,0 -2.358,-0.964 -2.358,-2.1l0,-9.858l-3.429,0l0,10.158c-0.001,3.216 2.487,5.144 5.787,5.144zm-16.575,-3.6l-2.571,0l0,-8.4l2.571,0c2.357,0 3.987,1.628 3.987,4.2s-1.629,4.2 -3.987,4.2zm0,3.301c4.137,0 7.286,-3.258 7.286,-7.501c0,-4.244 -3.149,-7.501 -7.286,-7.501l-6,0l0,15.002l6,0zm-10.359,0l0,-15.002l-3.429,0l0,15.002l3.429,0zm-12.93,0l0,-5.508l5.572,0l0,-3.301l-5.572,0l0,-2.893l5.68,0l0,-3.301l-9.109,0l0,15.002l3.429,0l0,0.001z",
  fill: "#1D325A"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 116,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/logo.e4409edb.svg";
export { SvgComponent as ReactComponent };